export default "__VITE_ASSET__17647865__"